import BaseController from "confinus_ui/base_controller";
import {
  hideElement,
  setElementHidden,
  unhideElement,
} from "lib/util/set_element_hidden";
import { setElementRequired } from "lib/util/set_element_required";

export default class RegistrationStep1Controller extends BaseController {
  public static targets = [
    "consumerChoices",
    "consumerPropertyTypeOtherCheckbox",
    "consumerPropertyTypeOtherTextFieldContainer",
    "consumerPropertyTypeOtherTextField",
  ];

  // private declare readonly consumerChoicesTarget: HTMLDivElement;
  declare private readonly consumerPropertyTypeOtherCheckboxTarget: HTMLInputElement;
  declare private readonly consumerPropertyTypeOtherTextFieldContainerTarget: HTMLDivElement;
  declare private readonly consumerPropertyTypeOtherTextFieldTarget: HTMLInputElement;

  public connect() {
    super.connect();
    this.toggleConsumerPropertyTypeOtherTextFieldControl(
      this.consumerPropertyTypeOtherCheckboxTarget.checked,
    );
  }

  public handleConsumerPropertyTypeOtherCheckboxToggle(evt: Event) {
    const { checked } = evt.target as HTMLInputElement;
    this.toggleConsumerPropertyTypeOtherTextFieldControl(checked);
  }

  private toggleConsumerPropertyTypeOtherTextFieldControl(reveal: boolean) {
    setElementHidden(
      this.consumerPropertyTypeOtherTextFieldContainerTarget,
      !reveal,
    );
    setElementRequired(this.consumerPropertyTypeOtherTextFieldTarget, reveal);
  }
}
